import { LogIn, UserPlus } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useSearchParams } from "react-router";
import { Button } from "@/components/ui/button";
import { authClient } from "@/lib/auth-client";
import { getAuthPath, isConsumerSession, isRestaurantSession } from "@/lib/auth-roles";

export function DeliveryLoginCta() {
  const { t } = useTranslation();
  const { data: session, isPending } = authClient.useSession();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  if (isPending) {
    return null;
  }

  if (session && (isConsumerSession(session) || isRestaurantSession(session))) {
    return null;
  }

  const queryString = searchParams.toString();
  const next = queryString ? `${location.pathname}?${queryString}` : location.pathname;
  const signInPath = getAuthPath("consumer", "sign-in", next);
  const signUpPath = getAuthPath("consumer", "sign-up", next);

  return (
    <div
      aria-label={t("delivery.menu.authCta.label", { defaultValue: "Cuenta de consumidor" })}
      className="flex items-center gap-2"
    >
      <Button asChild size="sm" variant="ghost">
        <Link to={signInPath}>
          <LogIn className="mr-1 h-4 w-4" />
          {t("delivery.menu.authCta.signIn", { defaultValue: "Iniciar sesión" })}
        </Link>
      </Button>
      <Button asChild size="sm" variant="outline">
        <Link to={signUpPath}>
          <UserPlus className="mr-1 h-4 w-4" />
          {t("delivery.menu.authCta.signUp", { defaultValue: "Crear cuenta" })}
        </Link>
      </Button>
    </div>
  );
}
